import type {Evaluator} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {GuideNode} from "#template/nodes/object/guide/guide-node"
import type {ObjectNodeDefinition, ObjectNodeParameters} from "#template/nodes/object/types"
import type {OnCompileContext, TemplateNodeContext, VisitorNodeResult} from "#template/template-node/types"
import {objectNodeParameters} from "#template/nodes/object/validation"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {SceneNodes} from "#template/interfaces/scene-object"
import {visitNone} from "#template/template-node/visit-helpers"

export type PlaneGuideParameters = {
    name: string
    width: number
    height: number
} & ObjectNodeParameters

const planeGuideDefinition: ObjectNodeDefinition<PlaneGuideParameters> = {
    nodeClass: "PlaneGuide",
    validation: {
        parameters: z.extend(
            z.object({
                name: z.string(),
                width: z.number(),
                height: z.number(),
            }),
            objectNodeParameters.shape,
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PlaneGuide extends GuideNode<PlaneGuideParameters> {
    public override get definition() {
        return planeGuideDefinition
    }

    public override onCompile(context: OnCompileContext, _evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<PlaneGuideParameters> {
        const {evaluator} = context
        const {width, height} = this.parameters

        const scope = evaluator.getScope(this)

        this.setupObject(scope, context, "Rectangle", undefined, undefined, (objectProps) => {
            return scope.struct<SceneNodes.Rectangle>("Rectangle", {
                type: "Rectangle",
                ...objectProps,
                width,
                height,
            })
        })

        return visitNone(this.parameters)
    }
}
